
import { useState, useEffect } from "react";

export type MetalType = "gold" | "silver";

interface UseMetalSelectionProps {
  initialMetal?: MetalType;
  onMetalChange?: (metal: MetalType) => void;
}

export function useMetalSelection({ initialMetal = "gold", onMetalChange }: UseMetalSelectionProps = {}) {
  const [activeMetal, setActiveMetal] = useState<MetalType>(initialMetal);

  // Notify parent component when active metal changes
  useEffect(() => {
    if (onMetalChange) {
      onMetalChange(activeMetal);
    }
  }, [activeMetal, onMetalChange]);

  const handleMetalClick = (metal: MetalType) => {
    setActiveMetal(metal);
  };

  return {
    activeMetal,
    handleMetalClick,
    setActiveMetal // Export setter for direct control if needed
  };
}
